import React, { useState } from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import { OutlinedTextInput, PrimaryButton, Text, SizeableRoundedDialog } from 'library';
import theme from 'theme';
import useLoading from 'library/hooks/useLoading';
import { formatShortWeekdayMonthDay } from 'shared/Dates';
import { ILeanShift } from '../../BusinessJob/models';
import { client } from 'shared';
import { isBefore } from 'date-fns';
import { IShift } from 'models';

export default function CancelModal({
    open,
    close,
    shift,
    providerName,
    refresh,
}: {
    open: boolean;
    close: () => void;
    shift: IShift | ILeanShift;
    providerName?: string;
    refresh: () => void;
}) {
    const small = useMediaQuery(theme.breakpoints.down('sm'));
    const { loading, setLoading } = useLoading();
    const [comment, setComment] = useState<string>();
    function submit() {
        setLoading(true);
        client(`api/business-appointment/${shift.id}/close/`, { method: 'POST', body: { comment } })
            .then(refresh)
            .finally(() => {
                setLoading(false);
                close();
            });
    }

    function isWithin12Hours() {
        const twelveHoursFromNow = new Date();
        twelveHoursFromNow.setHours(twelveHoursFromNow.getHours() + 12);
        return isBefore(new Date(shift.start_date), twelveHoursFromNow);
    }

    return (
        <SizeableRoundedDialog
            open={open}
            onClose={close}
            fullScreen={small}
            closeButton
            maxWidth="md"
            style={{ maxWidth: 500 }}
        >
            <Grid container item direction="column" style={{ padding: 20, gap: 10 }}>
                <Text variant="h1">Cancel shift for {formatShortWeekdayMonthDay(shift.start_date)}?</Text>
                {isWithin12Hours() && providerName ? (
                    <Text variant="body1" bold>
                        You're cancelling within 12 hours of the shift starting. You will be charged for 4 hours of this
                        shift due to the last minute cancellation
                    </Text>
                ) : null}
                <Text>
                    {providerName
                        ? `We will inform ${providerName} not to come this day, and we will not attempt to refill this shift.`
                        : 'We will no longer attempt to fill this shift.'}
                </Text>
                <OutlinedTextInput
                    label="Reason for cancelling"
                    style={{ padding: 10 }}
                    multiline
                    fullWidth
                    onChange={(e: any) => setComment(e.target.value)}
                    value={comment}
                />
                <PrimaryButton
                    disabled={loading}
                    onClick={submit}
                    buttonStyle={{ width: undefined, alignSelf: 'flex-end' }}
                >
                    Submit Cancellation
                </PrimaryButton>
            </Grid>
        </SizeableRoundedDialog>
    );
}
